/*
  Every figure the Wealth Report shows, in one place.

  All of it is placeholder, lifted from the design so the page can be read and
  judged before anything is wired up. Nothing here is computed and nothing reads
  the report's date range or currency yet. When each value's meaning is settled,
  this file is what changes — the sections render whatever they are handed.

  The colours are the design's own, sampled from the SVG rather than guessed.
  Two of the allocation blues are hard to tell apart; see ALLOCATION.
*/

export const CHART_COLORS = {
  navy: "#1b3a6b",
  blue: "#2e6bb8",
  sky: "#8fb8e0",
  pale: "#a9cbea",
  gold: "#c9a24b",
  grey: "#d8dee8",
};

/* ---------------------------------------------------- 1 executive summary */

export const SUMMARY_STATS = [
  { key: "net_worth", badge: "€", labelKey: "assetDashboardText16", value: "€27,450,000", delta: "8.7%", up: true },
  { key: "liabilities", badge: "AT", labelKey: "assetDashboardText17", value: "€5,410,000" },
  { key: "income", badge: "PT", labelKey: "assetDashboardText18", value: "€2,950,000" },
  { key: "liquidity", badge: "RA", labelKey: "assetDashboardText19", value: "€3,820,000" },
  { key: "illiquid", badge: "LD", labelKey: "assetDashboardText20", value: "€3,820,000" },
];

/*
  The Overall Asset Allocation ring is no longer placeholder — it is built from
  the user's own assets, grouped by financial exposure, in reportMetrics.js.
  Its colours live there too, beside the rule that hands them out.
*/

/*
  Geographic allocation is no longer placeholder — it is counted from the
  assets' own location entries in reportMetrics.js.
*/

export const RATIOS = [
  { key: "debt", labelKey: "assetDashboardText30", value: "16.5%" },
  { key: "liquidity", labelKey: "assetDashboardText31", value: "11.6%" },
  // Wealth Change — computed in ExecutiveSummary, no placeholder.
  { key: "return", labelKey: "assetDashboardText32", value: "—" },
];

/* -------------------------------------------------------- 2 wealth summary */

export const NET_ASSETS = [
  { key: "real_estate", labelKey: "assetDashboardText24", value: "€14,840,000", amount: 14840000, delta: "8.7%", up: true },
  { key: "financial", labelKey: "assetDashboardText25", value: "€9,230,000", amount: 9230000, delta: "8.7%", up: true },
  { key: "holdings", labelKey: "assetDashboardText26", value: "€5,780,000", amount: 5780000, delta: "8.7%", up: false },
  { key: "private_equity", labelKey: "assetDashboardText40", value: "€1,840,000", amount: 1840000, delta: "8.7%", up: true },
  { key: "crypto", labelKey: "assetDashboardText28", value: "€690,000", amount: 690000, delta: "8.7%", up: true },
  { key: "other", labelKey: "assetDashboardText29", value: "€480,000", amount: 480000, delta: "8.7%", up: false },
];

export const NET_ASSETS_TOTAL = { value: "€32,860,000", delta: "8.7%", up: true };

/*
  Sections 3 to 7 hold nothing here any more. The per-type sections are built
  from the asset types the account actually holds, and the income section from
  the assets that carry an income block — both in reportMetrics.js.
*/

/* --------------------------------------------------------------- 8 estate */

export const ESTATE_STEPS = [
  { key: "anticipate", titleKey: "assetDashboardText56", textKey: "assetDashboardText57" },
  { key: "organize", titleKey: "assetDashboardText58", textKey: "assetDashboardText59" },
  { key: "transfer", titleKey: "assetDashboardText60", textKey: "assetDashboardText61" },
  { key: "protect", titleKey: "assetDashboardText62", textKey: "assetDashboardText63" },
];

export const SUCCESSION_ROWS = [
  { key: "sophie", heir: "Sophie DURAND (spouse)", share: "25%", duties: "€612,500", net: "€5,037,500" },
  { key: "alexandre", heir: "Alexandre DURAND", share: "25%", duties: "€612,500", net: "€5,037,500" },
  { key: "camille", heir: "Camille DURAND", share: "25%", duties: "€612,500", net: "€5,037,500" },
  { key: "nicolas", heir: "Nicolas DURAND", share: "25%", duties: "€612,500", net: "€5,037,500" },
];

export const SUCCESSION_TOTAL = { share: "100%", duties: "€2,450,000", net: "€20,150,000" };

/* ------------------------------------------------------ 9 recommendations */

export const RECOMMENDATIONS = [
  { key: "diversification", titleKey: "assetDashboardText76", textKey: "assetDashboardText77" },
  { key: "structuring", titleKey: "assetDashboardText78", textKey: "assetDashboardText79" },
  { key: "succession", titleKey: "assetDashboardText80", textKey: "assetDashboardText81" },
  { key: "taxation", titleKey: "assetDashboardText82", textKey: "assetDashboardText83" },
  { key: "liquidity", titleKey: "assetDashboardText84", textKey: "assetDashboardText85" },
  { key: "philanthropy", titleKey: "assetDashboardText86", textKey: "assetDashboardText87" },
  { key: "governance", titleKey: "assetDashboardText88", textKey: "assetDashboardText89" },
];
